import { render, staticRenderFns } from "./ClassDetail.vue?vue&type=template&id=62d1dfdb&scoped=true&"
import script from "./ClassDetail.vue?vue&type=script&lang=js&"
export * from "./ClassDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassDetail.vue?vue&type=style&index=0&id=62d1dfdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d1dfdb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VChip,VCol,VRow,VSkeletonLoader})
